import React, { useState, useEffect, useRef } from 'react';

//3rd party
import moment from 'moment';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-toastify/dist/ReactToastify.css';
import { TailSpin } from  'react-loader-spinner';

//Functions
import { apiCall, apiError, notification } from '../functions/common';

//Components
import Datepicker from './Datepicker';
import Dropdown from './Dropdown';
import DropdownGhost from './DropdownGhost';
import Button from './Button';

//Styles
import '../css/timeform.css';
//import { notification } from 'antd';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const RegisterTimeForm = (props) => {
    const { t, loading: i18nLoading } = useTranslations();

    //Props
    const registerDate = props.registerDate;
    const changeDate = props.changeDate;
    const submitDate = props.submitDate;
    const getRegistrations = props.getRegistrations;
    const setOpenBackdrop = props.setOpenBackdrop;
    const afgeboekt = props.afgeboekt;
    const dataToEdit = props.dataToEdit;

    const loggedIn = localStorage.getItem('ingelogd');
    const code = global.settings.api.code;
    useEffect(() => {
        if (loggedIn === 'true') { 
            getOptions(); 
        }
    }, []);

    //Variables
    const [data, setData] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [allFormOptions, setAllFormOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [location, setLocation] = useState(dataToEdit ? dataToEdit.location : '');
    const [edit, setEdit] = useState(dataToEdit ? true : false);
    const [clientOptions, setClientOptions] = useState([]);
    const [client, setClient] = useState(dataToEdit ? dataToEdit.client : '');
    const [buildingNumbersOptions, setBuildingNumbersOptions] = useState([]);
    const [buildingNumber, setBuildingNumber] = useState(dataToEdit ? dataToEdit.buildingnumber : '');
    const [dekOptions, setDekOptions] = useState([]);
    const [dekOption, setDekOption] = useState(dataToEdit ? dataToEdit.dek : '');
    const [hourTypeOptions, setHourTypeOptions] = useState([]);
    const [hourType, setHourType] = useState(dataToEdit ? dataToEdit.hourtype : '');
    const [note, setNote] = useState(dataToEdit?.opmerking ?? '');
    const [workedHours, setWorkedHours] = useState(dataToEdit ? dataToEdit.aantal_uren : '');
    const submissionInProgress = useRef(false);
    const [newRegistrationObject, setNewRegistrationObject] = useState(
    dataToEdit ? 
    {klant:Number(dataToEdit.client),locatie:Number(dataToEdit.location),bouwnummer:Number(dataToEdit.buildingnumber),dek:Number(dataToEdit.dek),uren_soort:Number(dataToEdit.hourtype),aantal_uren:dataToEdit.aantal_uren,opmerking:dataToEdit.opmerking} 
    : 
    {klant:0,locatie:0,bouwnummer:0,dek:0,uren_soort:0,aantal_uren:0,opmerking:null}
    );
    const MAX_HOURS = 16;
    const MAX_NOTE_LENGTH = 30;

    //Fill array with options
    const setDropdownOptions = (data) => {
        var array = [];
        data.map((option, index) => {
            const obj = {
                value: option.value,
                label: option.label,
                actief: option.actief,
                extern: option.extern
            }
            array.push(obj);
        })
        return array;
    }

    const returnModifiedArray = (data) => {
        const obj = {
            value: data.value,
            label: data.label,
            actief: data.actief,
            extern: data.extern
        }
        return obj;
    }

    const setDropdownOptionsNew = (locations) => {
        var arrayLocations = [];
        var arrayClients = [];
        var arrayBuildingNumbers = [];
        var arrayDekken = [];
        var arrayUrensoorten = [];
        locations.map((location, index) => {
            //console.log(location);
            arrayLocations.push(returnModifiedArray(location));

            if(location.klanten){
                location.klanten.map((client, index) => {
                    //console.log(client);
                    arrayClients.push(returnModifiedArray(client));

                    if(client.bouwnummers){
                        client.bouwnummers.map((bouwnummer, index) => {
                            arrayBuildingNumbers.push(returnModifiedArray(bouwnummer));
                        })
                    } else {
                        client.bouwnummers = [];
                    }
                    if(client.dekken){
                        client.dekken.map((dek, index) => {
                            arrayDekken.push(returnModifiedArray(dek));
                        })
                    } else {
                        client.dekken = [];
                    }
                    /*if(client.uren_soorten){
                        client.uren_soorten.map((urensoort, index) => {
                            arrayUrensoorten.push(returnModifiedArray(urensoort));
                        })
                    } else {
                        client.uren_soorten = [];
                    }*/
                })

                if(location.uren_soorten){
                    location.uren_soorten.map((urensoort, index) => {
                        arrayUrensoorten.push(returnModifiedArray(urensoort));
                    })
                } else {
                    location.uren_soorten = [];
                }
            }
        })
        setLocationOptions(arrayLocations);
        setClientOptions(arrayClients);
        setBuildingNumbersOptions(arrayBuildingNumbers);
        setDekOptions(arrayDekken);
        setHourTypeOptions(arrayUrensoorten);
    }

    //Get field data via API
    const getOptions = async () => {
        try {
            const response = await apiCall(`locaties?code=${code}`);
            //console.log(response.data);

            // Success
            if (response.data.success) {
                const data = response.data.data;
                const locations = data.locaties;
                //console.log(locations);
                setData(locations);
                setDropdownOptionsNew(locations);
                if(dataToEdit){
                    //handleLocationChange(dataToEdit.location, locations);
                    //handleClientChange(dataToEdit.client, locations);
                }
            }
        } catch (error) {
            console.log(error);
            // Error
            if (error.response) {
              if (error.response.status === 401) {}
              if (error.response.status === 403) {}
              if (error.response.status === 429) {}
              if (error.response.status === 500) {}
            }
          }
    }

    const handleDateChange = (value) => {
        changeDate(value);
    }

    //Empty values because parent options has changed
    const emptyValues = (types) => {
        types.map((option, index) => {
            if (option === 'location') { setLocation('') }
            if (option === 'client') { setClient('') }
            if (option === 'buildingnumber') { setBuildingNumber('') }
            if (option === 'dek') { setDekOption('') }
            if (option === 'hourtype') { setHourType('') }
            if (option === 'note') {
                setNote('');
                setNewRegistrationObject(prev => ({ ...prev, opmerking: null }));
            }
            if (option === 'hours') {
                setWorkedHours('');
                setNewRegistrationObject(prev => ({ ...prev, aantal_uren: 0 }));
            }
            if (option === 'all') { setNewRegistrationObject({klant:0,locatie:0,bouwnummer:0,dek:0,uren_soort:0,aantal_uren:0,opmerking:null}); }
        })
    }

    const handleLocationChange = (selectedOption, locations) => {
        // Set location state
        setLocation(selectedOption);

        // Initialize clients and hourtypes arrays
        let clients = [];
        let hourtypes = [];

        // Iterate through data to find matching option
        locations.forEach((option) => {
            if (selectedOption == option.value) {
                clients = option.klanten;
                hourtypes = option.uren_soorten;
            }
        });

        // Clear values
        //if(!edit){
            emptyValues(['client','buildingnumber','dek']);
        //}

        // Update client and hour type options
        setClientOptions(setDropdownOptions(clients));
        setHourTypeOptions(setDropdownOptions(hourtypes));

        // Create new object and assign
        //if(!edit){
            const obj = { ...newRegistrationObject }; // Copy existing object
            obj.locatie = selectedOption;
            obj.klant = 0;
            obj.bouwnummer = 0;
            obj.dek = 0;
            obj.uren_soort = 0;
            setNewRegistrationObject(obj);
        //}
    }

    // Original handleChangeLocation function
    const handleChangeLocation = (event) => {
        handleLocationChange(event.target.value, data);
    }

    const handleClientChange = (selectedOption, locations) => {
        //console.log("vernader client met client: " + selectedOption);
        // Set client state
        setClient(selectedOption);

        // Initialize buildingNumbers and dekken arrays
        let buildingNumbers = [];
        let dekken = [];

        // Iterate through locations to find matching option
        locations.forEach((option) => {
            if (location == option.value) {
                option.klanten.forEach((clientOption) => {
                    if (selectedOption == clientOption.value) {
                        buildingNumbers = clientOption.bouwnummers;
                        dekken = clientOption.dekken;
                        //hourtypes = clientOption.uren_soorten;
                    }
                });
            }
        });

        // Clear values
        //if(!edit){
            emptyValues(['buildingnumber','dek','hourtype']);
        //}

        // Update building numbers and dekken options
        setBuildingNumbersOptions(setDropdownOptions(buildingNumbers));
        setDekOptions(setDropdownOptions(dekken));

        // Create new object and assign
        //if(!edit){
            const obj = { ...newRegistrationObject }; // Copy existing object
            obj.klant = selectedOption;
            obj.bouwnummer = 0;
            obj.dek = 0;
            obj.uren_soort = 0;
            setNewRegistrationObject(obj);
        //}
    }

    // Original handleChangeClient function
    const handleChangeClient = (event) => {
        const selectedOption = event.target.value;
        handleClientChange(selectedOption, data);
    }

    const handleChangeBuildingNumber = (event) => {
        const selectedBuildingNumber = event.target.value;
        setBuildingNumber(selectedBuildingNumber);
        
        //Create new object and assign
        var obj = { ...newRegistrationObject };
        obj.bouwnummer = selectedBuildingNumber;
        obj.dek = 0;
        obj.uren_soort = 0;
        setDekOption('');
        setHourType('');
        //console.log(obj.bouwnummer);
        //console.log(obj.locatie);
        //Specifieke situatie bij Heesen locatie en bouwnummer 258
        if(obj.bouwnummer == 258 /*&& obj.locatie == 4*/){
            let dekken = [{value: 157, label: 'Geen', actief: 1, extern: 0}];
            const onlyDek = dekken[0];
            const indirectHourTypes = data.find((option) => location == option.value)?.uren_soorten?.filter((hourType) => hourType.indirect == 1) || [];
            setDekOptions(setDropdownOptions(dekken));
            setDekOption(onlyDek.value);
            setHourTypeOptions(setDropdownOptions(indirectHourTypes));
            setHourType('');
            obj.dek = onlyDek.value;
            obj.uren_soort = 0;
        } else {
            const selectedLocation = data.find((option) => location == option.value);
            const selectedClient = selectedLocation?.klanten?.find((clientOption) => client == clientOption.value);

            setDekOptions(setDropdownOptions(selectedClient?.dekken || []));
            setHourTypeOptions(setDropdownOptions(selectedLocation?.uren_soorten || []));
        }
        setNewRegistrationObject(obj);
    }

    const handleChangeDek = (event) => {
        setDekOption(event.target.value);
        //Create new object and assign
        var obj = newRegistrationObject;
        obj.dek = event.target.value;
        setNewRegistrationObject(obj);
    }

    const handleChangeHourType = (event) => {
        setHourType(event.target.value);
        //Create new object and assign
        var obj = newRegistrationObject;
        obj.uren_soort = event.target.value;
        setNewRegistrationObject(obj);
    }

    const handleChangeNote = (event) => {
        const value = event.target.value.replace(/[\r\n]+/g, ' ').slice(0, MAX_NOTE_LENGTH);

        setNote(value);
        setNewRegistrationObject(prev => ({ ...prev, opmerking: value || null }));
    }

    const handleWorkedHours = (event) => {
      const raw = event.target.value;

      // Sta leegmaken toe
      if (raw === '' || raw === null || raw === undefined) {
        setWorkedHours('');
        setNewRegistrationObject(prev => ({ ...prev, aantal_uren: 0 }));
        return;
      }

      let val = parseFloat(raw);
      if (Number.isNaN(val)) return;

      // clamp 0..16
      val = Math.max(0, Math.min(MAX_HOURS, val));

      // round to nearest 0.25 and format
      const number = (Math.round(val * 4) / 4).toFixed(2);

      setWorkedHours(number);
      setNewRegistrationObject(prev => ({ ...prev, aantal_uren: number }));
    };

    //Submit registration
    const submitRegistration = async () => {
        //Validate fields
        if (!newRegistrationObject.locatie) { notification('error', t('select_location', 'Select a location')); return; }
        if (!newRegistrationObject.klant) { notification('error', t('select_client', 'Select a client')); return; }
        if (!newRegistrationObject.bouwnummer) { notification('error', t('select_construction_number', 'Select a construction number')); return; }
        if (!newRegistrationObject.dek) { notification('error', t('select_deck', 'Select a deck')); return; }
        if (!newRegistrationObject.uren_soort) { notification('error', t('select_hour_type', 'Select an hour type')); return; }
        if (!submitDate) { notification('error', t('select_date', 'Select a date')); return; }
        if (!workedHours || workedHours === '0.00') { notification('error', t('fill_worked_hours', 'Fill in the worked hours')); return; }
        if (afgeboekt) { notification('error', t('day_already_submitted', 'This day is already submitted')); return; }
        if (submissionInProgress.current) { return; }

        submissionInProgress.current = true;

        if (dataToEdit) {
            setIsUpdating(true);
        }

        // The controlled field is the source of truth. This prevents a cleared
        // note from being replaced by a stale value in newRegistrationObject.
        const registrationToSubmit = {
            ...newRegistrationObject,
            opmerking: note || null
        };
        const dataObj = encodeURIComponent(JSON.stringify(registrationToSubmit));
        if (!dataToEdit) { setOpenBackdrop(true) }

        //Call API
        try {
            let url = `registratie?code=${code}&datum=${submitDate}&rij=${dataObj}`;
            if(dataToEdit){
                url = url + `&rij_id=${dataToEdit.row_id}`;
            }
            const response = await apiCall(url, 'post');

            // Success
            if (response.data.success) {
                getRegistrations(submitDate);
                if(newRegistrationObject.locatie == 11){//Werkplaats Gemini, checken of dit ook zo is op production
                    //legen
                    //console.log("legen");
                    emptyValues(['client','buildingnumber','dek','hourtype','note','hours']);
                } else {
                    emptyValues(['note']);
                }
            } else {
                notification('error', response.error);
            }
        } catch (error) {
            // Error
            apiError(error);
            if (!dataToEdit) { setOpenBackdrop(false) }
        } finally {
            submissionInProgress.current = false;
            setIsUpdating(false);
        }
    }

    //console.log(locationOptions);

    return (
        <div className="default-form">
            {/* Date field */}
            <div className="form-field date">
                {
                    dataToEdit
                        ? <DropdownGhost label={dataToEdit.showDate} />
                        : <Datepicker date={registerDate} changeDate={handleDateChange} />
                }
            </div>

            {/* Location field */}
            <div className="form-field">
                {
                    locationOptions.length > 0
                        ? <Dropdown
                            placeholder={t('which_location_q', 'Which location?')}
                            value={location}
                            label={t('which_location_q', 'Which location?')}
                            onChange={handleChangeLocation}
                            source={locationOptions}
                            modify={!!dataToEdit}
                        />
                        : <Skeleton height={40} />
                }
            </div>

            {/* Client field */}
            <div className="form-field">
                {
                    locationOptions.length > 0 && location
                        ? <Dropdown
                            placeholder={!location ? t('select_location_first', 'Select a location first') : t('which_client_q', 'Which client?')}
                            value={client}
                            label={t('which_client_q', 'Which client?')}
                            onChange={handleChangeClient}
                            source={clientOptions}
                            modify={!!dataToEdit}
                        />
                        : (
                            <div>
                                {locationOptions.length === 0
                                    ? <Skeleton height={40} />
                                    : <DropdownGhost label={t('select_location_first', 'Select a location first')} />
                                }
                            </div>
                        )
                }
            </div>

            {/* Construction number field */}
            <div className="form-field">
                {
                    locationOptions.length > 0 && client
                        ? <Dropdown
                            placeholder={!client ? t('select_client_first', 'Select a client first') : t('which_construction_number_q', 'Which construction number?')}
                            value={buildingNumber}
                            label={t('which_construction_number_q', 'Which construction number?')}
                            onChange={handleChangeBuildingNumber}
                            source={buildingNumbersOptions}
                            modify={!!dataToEdit}
                        />
                        : (
                            <div>
                                {locationOptions.length === 0
                                    ? <Skeleton height={40} />
                                    : <DropdownGhost label={t('select_client_first', 'Select a client first')} />
                                }
                            </div>
                        )
                }
            </div>

            {/* Dek field */}
            <div className="form-field">
                {
                    locationOptions.length > 0 && client
                        ? <Dropdown
                            placeholder={!client ? t('select_client_first', 'Select a client first') : t('which_deck_q', 'Which deck?')}
                            value={dekOption}
                            label={t('which_deck_q', 'Which deck?')}
                            onChange={handleChangeDek}
                            source={dekOptions}
                            modify={!!dataToEdit}
                        />
                        : (
                            <div>
                                {locationOptions.length === 0
                                    ? <Skeleton height={40} />
                                    : <DropdownGhost label={t('select_client_first', 'Select a client first')} />
                                }
                            </div>
                        )
                }
            </div>

            {/* Hourtype field */}
            <div className="form-field">
                {
                    locationOptions.length > 0 && client
                        ? <Dropdown
                            placeholder={!client ? t('select_client_first', 'Select a client first') : t('hour_type', 'Hour type')}
                            value={hourType}
                            label={t('hour_type', 'Hour type')}
                            onChange={handleChangeHourType}
                            source={hourTypeOptions}
                            internExtern={true}
                        />
                        : (
                            <div>
                                {locationOptions.length === 0
                                    ? <Skeleton height={40} />
                                    : <DropdownGhost label={t('select_client_first', 'Select a client first')} />
                                }
                            </div>
                        )
                }
            </div>

            {/* Optional notes field */}
            <div className="form-field">
                {
                    locationOptions.length > 0
                        ? <textarea
                            value={note}
                            onChange={handleChangeNote}
                            maxLength={MAX_NOTE_LENGTH}
                            placeholder={t('optional_notes_placeholder', 'Optional notes, example: own transport')}
                        />
                        : <Skeleton height={40} />
                }
                <div className="note-counter">
                    {note.length}/{MAX_NOTE_LENGTH}
                </div>
            </div>

            {/* Submit form */}
            <div className="registration-submit">
                <input
                    type="number"
                    value={workedHours}
                    onBlur={handleWorkedHours}
                    onChange={(e) => setWorkedHours(e.target.value)}
                    placeholder={t('hours_placeholder', '00:00')}
                    step="0.25"
                    min="0"
                    max="16"
                />
                {
                    isUpdating
                        ? (
                            <TailSpin
                                height="30"
                                width="30"
                                color="#13a3f6"
                                ariaLabel="tail-spin-loading"
                                radius="1"
                                wrapperStyle={{
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                wrapperClass=""
                                visible={true}
                            />
                        )
                        : (
                            <Button
                                text={dataToEdit ? t('save', 'Save') : t('add_hours', 'Add hours')}
                                onClick={() => submitRegistration()}
                                style={{ width: "50%", marginBottom: 0 }}
                            />
                        )
                }
            </div>

            {
                !dataToEdit
                    ? <button onClick={() => emptyValues(['location', 'client', 'buildingnumber', 'dek', 'hourtype', 'note', 'hours', 'all'])} className="reset">
                        {t('reset', 'Reset')}
                    </button>
                    : null
            }
        </div>
    );
}

export default RegisterTimeForm;
